"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogger = void 0;
const immer_1 = require("immer");
const R = __importStar(require("ramda"));
const rxjs_1 = require("rxjs");
const getLogger = (options) => {
    return (0, immer_1.freeze)(new SimpleLogger(options));
};
exports.getLogger = getLogger;
class SimpleLogger {
    constructor(options) {
        var _a, _b;
        this.options = options;
        this.startTime = Date.now();
        this.subject = new rxjs_1.ReplaySubject();
        this.level = (_a = options.level) !== null && _a !== void 0 ? _a : "silent";
        this.name = (_b = options.name) !== null && _b !== void 0 ? _b : "";
    }
    setCallback(callback) {
        this.callback = callback;
    }
    getMessages() {
        return this.subject.asObservable();
    }
    fatal(msg, obj) {
        this.log("fatal", msg, obj);
    }
    error(msg, obj) {
        this.log("error", msg, obj);
    }
    warn(msg, obj) {
        this.log("warn", msg, obj);
    }
    info(msg, obj) {
        this.log("info", msg, obj);
    }
    debug(msg, obj) {
        this.log("debug", msg, obj);
    }
    trace(msg, obj) {
        this.log("trace", msg, obj);
    }
    levelOrder(level) {
        switch (level) {
            case "silent": return 0;
            case "trace": return 10;
            case "debug": return 20;
            case "info": return 30;
            case "warn": return 40;
            case "error": return 50;
            case "fatal": return 60;
        }
    }
    formatDeltaTime(deltaMs) {
        return `${deltaMs.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true })} ms`;
    }
    formatLevel(level) {
        switch (level) {
            case "silent": return "SILENT";
            case "trace": return "TRACE";
            case "debug": return "DEBUG";
            case "info": return "INFO";
            case "warn": return "WARN";
            case "error": return "ERROR";
            case "fatal": return "FATAL";
        }
    }
    log(level, msg, obj) {
        const notShow = this.level === "silent" || this.levelOrder(level) < this.levelOrder(this.level);
        if (notShow && R.isNil(this.callback)) {
            return;
        }
        const deltaMs = Date.now() - this.startTime;
        const deltaStr = this.formatDeltaTime(deltaMs);
        const levelStr = this.formatLevel(level);
        const message = `${levelStr} [${deltaStr}] ${this.name} > "${msg}"`;
        const logMessage = (0, immer_1.freeze)({ level: level, message, object: obj });
        if (!R.isNil(this.callback)) {
            this.callback(logMessage);
        }
        if (notShow) {
            return;
        }
        switch (level) {
            case "silent":
                throw new Error("Logger error. Silent cannot be there.");
            case "trace":
                R.isNil(obj) ? console.trace(message) : console.trace(message, obj);
                break;
            case "debug":
                R.isNil(obj) ? console.debug(message) : console.debug(message, obj);
                break;
            case "info":
                R.isNil(obj) ? console.info(message) : console.info(message, obj);
                break;
            case "warn":
                R.isNil(obj) ? console.warn(message) : console.warn(message, obj);
                break;
            case "error":
            case "fatal":
                R.isNil(obj) ? console.error(message) : console.error(message, obj);
                break;
        }
        if (this.options.storeMessages) {
            this.subject.next(logMessage);
        }
    }
}
//# sourceMappingURL=logger.js.map